const hotels = {
  accommodation: "ที่พัก", // translated
  hotel: "โรงแรม", // translated
  hotels: "โรงแรม", // translated
  back: "กลับ", // translated
  rooms: "ห้องพัก", // translated
  viewPictures: "ดูภาพ", // translated
  showMore: "แสดงมากขึ้น", // translated
  bookingInformation: "ข้อมูลการจอง", // translated
  cancellationPolicy: "นโยบายการยกเลิก", // translated
  from: "จาก", // translated
  to: "ถึง", // translated
  cancellationIs: "การยกเลิกคือ", // translated
  free: "ฟรี", // translated
  chargeableWithFeeOf: "โดยมีค่าธรรมเนียมเป็น", // translated
  prebook: "จองล่วงหน้า", // translated
  guests: "แขก", // translated
  payment: "การชำระเงิน", // translated
  byClicking: "โดยคลิก", // translated
  next: "ต่อไป", // translated
  youAreAgreeingToOur: "คุณเห็นด้วยกับเรา", // translated
  termsAndConditions: "ข้อกำหนดและเงื่อนไข", // translated
  previous: "ก่อนหน้า", // translated
  cancel: "ยกเลิก", // translated
  mealPlan: "มื้ออาหาร", // translated
  roomType: "ประเภทห้อง", // translated
  description: "คำอธิบาย", // translated
  readLess: "อ่านน้อยลง", // translated
  readMore: "อ่านเพิ่มเติม", // translated
  facilities: "สิ่งอำนวยความสะดวก", // translated
  viewLess: "ดูน้อยลง", // translated
  viewMore: "ดูเพิ่มเติม", // translated
  less: "น้อย", // translated
  more: "มากกว่า", // translated
  notAvailable_short: "ไม่มี", // translated
  backToHotelList: "กลับไปที่รายชื่อโรงแรม", // translated
  viewOnMap: "ดูบนแผนที่", // translated
  sleeps: "นอน", // translated
  adults: "ผู้ใหญ่", // translated
  yearsOld: "ปี", // translated
  type: "พิมพ์", // translated
  bedding: "เครื่องนอน", // translated
  selectRoom: "เลือกห้อง", // translated
  selectRooms: "เลือกห้อง", // translated
  city: "เมือง", // translated
  checkIn: "เช็คอิน", // translated
  checkOut: "เช็คเอาท์", // translated
  date: "วันที่", // translated
  dates: "วันที่", // translated
  persons: "บุคคล", // translated
  stillOnTrialQuestionToUpgrade: "อ๊ะ! ดูเหมือนว่าคุณยังเป็นสมาชิกแบบทดลองใช้อยู่ คุณต้องเป็นสมาชิกที่ได้รับการยืนยันจึงจะทำการจองได้ คุณต้องการอัพเกรดตอนนี้หรือไม่?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "อ๊ะ! ดูเหมือนว่าคุณยังไม่ได้สมัครรับข้อมูล คุณต้องเป็นสมาชิกที่ได้รับการยืนยันจึงจะทำการจองได้ คุณต้องการอัพเกรดตอนนี้หรือไม่?", // translated
  completeProfile: "กรุณากรอกโปรไฟล์ผู้ใช้ของคุณก่อน", // translated
  upgrade: "อัพเกรด", // translated
  close: "ปิด", // translated
  viewDetails: "ดูรายละเอียด", // translated
  name: "ชื่อ", // translated
  rating: "เรตติ้ง", // translated
  budget: "คะแนน", // translated
  orderBy: "กรองโดย", // translated
  priceLowestFirst: "ราคา (ต่ำสุดก่อน)", // translated
  priceHighestFirst: "ราคา (สูงสุดก่อน)", // translated
  ratingLowestFirst: "เรตติ้ง (ต่ำสุดก่อน)", // translated
  ratingHighestFirst: "เรตติ้ง (สูงสุดก่อน)", // translated
  starRatingAndPrice: "ระดับดาวและราคา", // translated
  biggestSavingsFirst: "ประหยัดเงิน(สูงสุดก่อน)", // translated
  select: "เลือก", // translated
  reset: "รีเซ็ต", // translated
  apply: "นำมาใช้", // translated
  filterBy: "กรองตาม", // translated
  myProfile: "ประวัติของฉัน", // translated
  login: "เข้าสู่ระบบ", // translated
  roomOnly: "ห้องเท่านั้น", // translated
  bedAndBreakfast: "ที่พักพร้อมอาหารเช้า", // translated
  halfBoard: "ฮาล์ฟบอร์ด", // translated
  fullBoard: "อาหารสามมื้อ", // translated
  allInclusive: "รวมทุกอย่าง", // translated
  filter: "กรอง", // translated
  mapView: "มุมมองแผนที่", // translated
  results: "ผลลัพธ์", // translated
  listView: "มุมมองรายการ", // translated
  newSearch: "การค้นหาใหม่", // translated
  editSearch: "แก้ไขการค้นหา", // translated
  all: "ทั้งหมด", // translated
  multiple: "หลายรายการ", // translated
  editProfile: "แก้ไขโปรไฟล์", // translated
  backToHotelsList: "กลับไปที่รายการโรงแรม", // translated
  roomName: "ชื่อห้อง", // translated
  mealType: "ประเภทมื้ออาหาร", // translated
  freeCancellation: "ยกเลิกฟรี", // translated
  yes: "ใช่", // translated
  no: "เลขที่", // translated
  filters: "ตัวกรอง", // translated
  cancellationNonRefundable: "การยกเลิกไม่สามารถคืนเงินได้", // translated
  hotelRating: "การให้คะแนนโรงแรม", // translated
  any: "ใดๆ", // translated
  off: "ปิด", // translated
  performNewSearch: "ทำการค้นหาใหม่", // translated
};


export default hotels;
